import React from 'react'
import {useEffect, useState} from "react";
import axios from "axios";
import {BASE_URL} from "../../utils/commonUrl";
import { render } from 'react-dom'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

const MatrixAssessmentChart = ({quarterID}) =>{

  const [skillMatrixAvgData, setSkillMatrixAvgData] = useState([])

    useEffect(()=>{
        GetCompetencyAvgData(quarterID)
    },[quarterID])

    const GetCompetencyAvgData = (id) => {
        id = parseInt(id) < 0 ? 0 : id;
        axios.post(BASE_URL + `/api/dashboard/GetSkillMatrixAvgData/${id}`)
            .then(response => {
              setSkillMatrixAvgData(response.data)
            }).catch(console.error)
    }

    const _yData = skillMatrixAvgData.map((data) => data.matrixTitle);
  const _dataValue = skillMatrixAvgData.map((data) => data.avgWeight);

  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Skill Matrix",
    },
    plotOptions: {
      column: {
          colorByPoint: true
      }
  },
  colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
    xAxis: {
      type: "category",
      labels: {
        rotation: -25,
        style: {
          fontSize: "13px",
          fontFamily: `'Poppins', sans-serif`,
        },
      },
      categories: _yData,
    },
    yAxis: {
      min: 1,
      title: {
        text: "Weight",
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      pointFormat: "Skill Matrix: <b>{point.y:.1f}</b>",
    },
    series: [
      {
        name: "Skill Matrix",
        data: _dataValue,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;

}

export default MatrixAssessmentChart;